<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Search Penalty</h4>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="control-label text-left"
              >Vehicle/External Reference:</label
            >
            <input
              name="terms"
              type="text"
              class="form-control"
              v-model="filters.terms"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <form-button
            class="btn btn-primary btn-block"
            :indicator="searching"
            @clicked="search"
          >
            Search
          </form-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <table class="table mt-3" v-if="!searching && penalties">
            <thead>
              <tr>
                <th>Claim Reference</th>
                <th>Issuing Authority</th>
                <th>External Reference</th>
                <th>Type</th>
                <th>Vehicle</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-bind:key="index"
                v-for="(penalty, index) in filteredPenalties"
              >
                <td>{{ penalty.hire?.incident?.source?.claim_reference }}</td>
                <td>
                  {{ penalty.issuing_authority?.name || 'Not Available' }}
                </td>
                <td>{{ penalty.external_reference || 'Not Available' }}</td>
                <td>{{ penalty.penalty_type?.label || 'Not Available' }}</td>
                <td>{{ penalty.vehicle?.registration || 'Not Available' }}</td>
                <td>
                  <form-button
                    :indicator="adding && clickedPenaltyIndex === index"
                    v-on:clicked="addPenalty(penalty, index)"
                  >
                    Add Penalty
                  </form-button>
                </td>
              </tr>
              <tr v-if="!filteredPenalties.length">
                <td class="text-center" colspan="5">
                  No penalties found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </modal>
</template>
<script>
export default {
  props: {
    recharge: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      searching: false,
      claim_reference: null,
      adding: false,
      clickedPenaltyIndex: -1,
      penalties: [],
      incidents: [],
      incident_id: null,
      filters: {
        incident_id: null,
        terms: ''
      }
    };
  },

  mounted() {
    this.filters.incident_id = this.recharge?.incident_id;

    this.search();
  },

  computed: {
    rechargePenalties() {
      return this.$store.getters['Recharges/penalties'];
    },

    filteredPenalties() {
      return this.penalties.filter(
        penalty => !this.rechargePenalties.find(p => p.id === penalty.id)
      );
    }
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },

    addPenalty(penalty, index) {
      this.clickedPenaltyIndex = index;

      this.adding = true;

      window.Ajax.put(
        `/recharges/${this.recharge.identifier}/add-penalty?parts=incident,penalties`,
        { penalty_id: penalty.id }
      )
        .then(response => {
          this.$emit('added', response.data);
          this.adding = false;
          this.clickedPenaltyIndex = -1;
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error adding the penalty'
          );

          this.adding = false;
          this.clickedPenaltyIndex = -1;
        });
    },

    search() {
      if (this.filters) {
        this.searching = true;

        let url = `/penalties?parts=hire,issuingAuthority,penaltyType,vehicle`;

        Object.keys(this.filters).forEach(key => {
          url = `${url}&filter[${key}]=${this.filters[key]}`;
        });

        window.Ajax.get(url)
          .then(response => {
            this.penalties = response.data;
            this.searching = false;
          })
          .catch(error => {});
      }
    }
  }
};
</script>
